import { render, staticRenderFns } from "./FormBuildersList.vue?vue&type=template&id=17ecbacc&scoped=true"
import script from "./FormBuildersList.vue?vue&type=script&lang=js"
export * from "./FormBuildersList.vue?vue&type=script&lang=js"
import style0 from "./FormBuildersList.vue?vue&type=style&index=0&id=17ecbacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecbacc",
  null
  
)

export default component.exports